module.exports = __webpack_public_path__ + "img/checkbox-marked-circle.00d972b1.svg";